import React from "react";
type SVGChartProps = { className?: string };
const SVGChart: React.FC<SVGChartProps> = (props) => (
	<svg
		width="14"
		height="13"
		viewBox="0 0 14 13"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={props?.className}
	>
		<path
			d="M12.3332 12.3333V7.66667M6.99984 12.3333V5.66667M1.6665 12.3333L1.6665 9.66667M7.93762 2.35167L11.3832 3.64378M6.19902 2.60061L2.46666 5.39989M13.0403 3.29289C13.4308 3.68342 13.4308 4.31658 13.0403 4.70711C12.6498 5.09763 12.0166 5.09763 11.6261 4.70711C11.2355 4.31658 11.2355 3.68342 11.6261 3.29289C12.0166 2.90237 12.6498 2.90237 13.0403 3.29289ZM2.37361 5.29289C2.76413 5.68342 2.76413 6.31658 2.37361 6.70711C1.98309 7.09763 1.34992 7.09763 0.959397 6.70711C0.568873 6.31658 0.568873 5.68342 0.959397 5.29289C1.34992 4.90237 1.98309 4.90237 2.37361 5.29289ZM7.70694 1.29289C8.09747 1.68342 8.09747 2.31658 7.70694 2.70711C7.31642 3.09763 6.68325 3.09763 6.29273 2.70711C5.90221 2.31658 5.90221 1.68342 6.29273 1.29289C6.68325 0.902369 7.31642 0.902369 7.70694 1.29289Z"
			stroke="#53B1FD"
			stroke-width="1.25"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);
export default SVGChart;
